module.exports = __webpack_public_path__ + "src/assets/textures/env/wagon/wagon_left_front_wheel_512_bake.png";